import React, { ReactNode, useEffect } from "react";
import { ThemeProvider as ThemeContextProvider } from "./ThemeContext";
import { applyThemeToElement } from "./theme.utils";
import themeV1 from "./theme-v1.json";

interface ThemeProviderProps {
  children: ReactNode;
  theme?: typeof themeV1;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  theme = themeV1
}) => {
  useEffect(() => {
    // Apply theme colors as CSS custom properties
    applyThemeToElement(theme);
  }, [theme]);

  return (
    <ThemeContextProvider initialTheme={theme}>{children}</ThemeContextProvider>
  );
};

export default ThemeProvider;
